import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { marked } from "marked";
import DOMPurify from "dompurify";
@Component({
  selector: "app-markdown",
  imports: [],
  templateUrl: "./markdown.component.html",
  styleUrl: "./markdown.component.scss",
})
export class MarkdownComponent implements OnInit {
  @Input({ required: true }) markdown: string;

  markdownHtml = "";

  ngOnInit(): void {
    this.markdownHtml = DOMPurify.sanitize(marked.parse(this.markdown) as string,  { USE_PROFILES: { html: true } });
  }
}
